/**
 * Central backend URL resolver.
 *
 * Historical problem: 68 files across the codebase do something like
 *
 *     const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
 *
 * If the env variable is missing at build time, the bundle contains the
 * literal string "undefined" and every fetch call hits /undefined/api/...
 * on the frontend's own origin — which returns 405 and looks broken.
 *
 * This helper centralises the logic so there is exactly one place to keep
 * consistent:
 *   - missing or empty env        -> falls back to same-origin (""), so fetch
 *                                    goes to /api/... on the current host.
 *                                    Works when the backend is reverse-proxied
 *                                    under the same domain as the frontend.
 *   - trailing slash              -> stripped.
 *   - accidental /api suffix      -> stripped (prevents /api/api/...).
 *   - build-time "undefined"      -> treated as missing (the bug above).
 */

function resolveBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim();

  // Guard against the literal string "undefined" that sneaks in when a
  // template string interpolates a missing env variable at build time.
  if (!raw || raw === 'undefined' || raw === 'null') {
    if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
      // eslint-disable-next-line no-console
      console.warn(
        '[config] REACT_APP_BACKEND_URL is not set. Falling back to same-origin. ' +
          'Set REACT_APP_BACKEND_URL=https://<your-backend-domain> in .env.production ' +
          'or in your host build-time env and redeploy.'
      );
    }
    return '';
  }

  // Remove any trailing slashes and a stray /api suffix.
  return raw.replace(/\/+$/, '').replace(/\/api$/, '');
}

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

export default BACKEND_URL;
